import type { IClassroomStudentRepository } from './interfaces/IClassroomStudentRepository'
import type { IVirtualClassroomRepository } from './interfaces/IVirtualClassroomRepository'
import type { ICourseRepository } from './interfaces/ICourseRepository'
import type { IUserRepository } from './interfaces/IUserRepository'
import type { IClassroomResultRepository } from './interfaces/IClassroomResultRepository'
import type { IStudentAnswerRepository } from './interfaces/IStudentAnswerRepository'
import type { IClassroomQuestionRepository } from './interfaces/IClassroomQuestionRepository'
import type { ILegalConsentRepository } from './interfaces/ILegalConsentRepository'

import { FirestoreClassroomStudentRepository } from './FirestoreClassroomStudentRepository'
import { FirestoreVirtualClassroomRepository } from './FirestoreVirtualClassroomRepository'
import { FirestoreCourseRepository } from './FirestoreCourseRepository'
import { FirestoreUserRepository } from './FirestoreUserRepository'
import { FirestoreClassroomResultRepository } from './FirestoreClassroomResultRepository'
import { FirestoreStudentAnswerRepository } from './FirestoreStudentAnswerRepository'
import { FirestoreClassroomQuestionRepository } from './FirestoreClassroomQuestionRepository'
import { FirestoreLegalConsentRepository } from './FirestoreLegalConsentRepository'

// Singletons
let classroomStudentRepo: IClassroomStudentRepository | null = null
let virtualClassroomRepo: IVirtualClassroomRepository | null = null
let courseRepo: ICourseRepository | null = null
let userRepo: IUserRepository | null = null
let classroomResultRepo: IClassroomResultRepository | null = null
let studentAnswerRepo: IStudentAnswerRepository | null = null
let classroomQuestionRepo: IClassroomQuestionRepository | null = null
let legalConsentRepo: ILegalConsentRepository | null = null

// Getters (DIP - depend on abstractions)
export function getClassroomStudentRepository(): IClassroomStudentRepository {
  if (!classroomStudentRepo) {
    classroomStudentRepo = new FirestoreClassroomStudentRepository()
  }
  return classroomStudentRepo
}

export function getVirtualClassroomRepository(): IVirtualClassroomRepository {
  if (!virtualClassroomRepo) {
    virtualClassroomRepo = new FirestoreVirtualClassroomRepository()
  }
  return virtualClassroomRepo
}

export function getCourseRepository(): ICourseRepository {
  if (!courseRepo) {
    courseRepo = new FirestoreCourseRepository()
  }
  return courseRepo
}

export function getUserRepository(): IUserRepository {
  if (!userRepo) {
    userRepo = new FirestoreUserRepository()
  }
  return userRepo
}

export function getClassroomResultRepository(): IClassroomResultRepository {
  if (!classroomResultRepo) {
    classroomResultRepo = new FirestoreClassroomResultRepository()
  }
  return classroomResultRepo
}

export function getStudentAnswerRepository(): IStudentAnswerRepository {
  if (!studentAnswerRepo) {
    studentAnswerRepo = new FirestoreStudentAnswerRepository()
  }
  return studentAnswerRepo
}

export function getClassroomQuestionRepository(): IClassroomQuestionRepository {
  if (!classroomQuestionRepo) {
    classroomQuestionRepo = new FirestoreClassroomQuestionRepository()
  }
  return classroomQuestionRepo
}

export function getLegalConsentRepository(): ILegalConsentRepository {
  if (!legalConsentRepo) {
    legalConsentRepo = new FirestoreLegalConsentRepository()
  }
  return legalConsentRepo
}

// Setters (for testing)
export function setClassroomStudentRepository(repo: IClassroomStudentRepository): void {
  classroomStudentRepo = repo
}

export function setVirtualClassroomRepository(repo: IVirtualClassroomRepository): void {
  virtualClassroomRepo = repo
}

export function setCourseRepository(repo: ICourseRepository): void {
  courseRepo = repo
}

export function setUserRepository(repo: IUserRepository): void {
  userRepo = repo
}

export function setClassroomResultRepository(repo: IClassroomResultRepository): void {
  classroomResultRepo = repo
}

export function setStudentAnswerRepository(repo: IStudentAnswerRepository): void {
  studentAnswerRepo = repo
}

export function setClassroomQuestionRepository(repo: IClassroomQuestionRepository): void {
  classroomQuestionRepo = repo
}

export function setLegalConsentRepository(repo: ILegalConsentRepository): void {
  legalConsentRepo = repo
}
